import React, { Component } from 'react';

import './ConflictItem.module.scss';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const months = [ 'januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', ' december' ];
const days = [ 'Zondag','Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag' ];

export class ConflictItem extends Component {

    constructor(props) {
        super(props);

        this.handleClick            = this.handleClick.bind(this);
    }

    handleClick() {
        this.props.goToDate(this.props.date);
    }

    render() {
        const { conflictAmount, timeslot, date } = this.props;
        const dateObject = new Date(date);

        const month = months[dateObject.getMonth()];
        const dayOfWeek = days[dateObject.getDay()];

        return (
            <div onClick={this.handleClick} styleName='conflict-wrapper'>
                <div styleName='left'>
                    <h2>{dayOfWeek}</h2>
                    <p>{`${dateObject.getDate()} ${month} - ${timeslot}e uur`}</p>
                </div>
                <div styleName='right'>
                    <div styleName='circle'>
                        <h2>{conflictAmount}</h2>
                    </div>
                    <FontAwesomeIcon styleName='icon' icon={[ 'far', 'angle-right' ]} />
                </div>
            </div>
        );
    }
}

export default ConflictItem;
